import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/atoms/Table';
import { Title } from '@/components/atoms/Title';
import { Text } from '@/components/atoms/Text';
import { SvyButton } from '@/components/savory/SvyButton';
import { HeaderLeft, HeaderRight, Subtitle } from '@/components/atoms/Section/Section.style';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import DeleteModal from '@/components/atoms/DeleteModal';
import { ConfirmReloadModal } from '@/pages/PromotionalBanners/components/ConfirmReloadModal/ConfirmReloadModal';
import { useBrandTabRoutes } from '../hooks/useBrandTabRoutes';

import { useBrandPromotionalBannersVM } from './BrandPromotionalBanners.viewmodel';
import { Container, HeaderContainer, Header } from './BrandPromotionalBanners.style';
import { BrandPromotionalBannerModal } from './components/BrandPromotionalBannerModal/BrandPromotionalBannerModal';
import { CarouselDelayCard } from './components/CarouselDelayCard/CarouselDelayCard';

export const BrandPromotionalBanners: React.FunctionComponent = () => {
    const {
        headers,
        rows,
        isLoading,
        brandId,
        carouselDelayMs,
        isSavingCarouselDelay,
        brandRestaurants,
        schedulesMap,
        action,
        clearAction,
        openCreateModal,
        customRowProps,
        handleRowClick,
        handleDelete,
        saveCarouselDelay,
        bulkReload,
    } = useBrandPromotionalBannersVM();

    const tabRoutes = useBrandTabRoutes();

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <BrandPromotionalBannerModal
                isOpen={action.type === 'create' || action.type === 'edit'}
                mode={action.type === 'edit' ? 'edit' : 'create'}
                banner={action.banner}
                brandId={brandId}
                restaurants={brandRestaurants}
                schedulesMap={schedulesMap}
                onHide={clearAction}
            />

            <DeleteModal
                isOpen={action.type === 'delete'}
                onHide={clearAction}
                onSubmit={() => action.banner && handleDelete(action.banner)}
                title="brandPromotionalBanner.delete.title"
                description="brandPromotionalBanner.delete.message"
            />

            <ConfirmReloadModal
                isOpen={bulkReload.isOpen}
                restaurantCount={bulkReload.restaurantCount}
                onConfirm={bulkReload.onConfirm}
                onCancel={bulkReload.onCancel}
            />

            <Container>
                <HeaderContainer>
                    <Header>
                        <HeaderLeft>
                            <Title text="brandPromotionalBanner.page.title" />
                            <Subtitle>
                                <Text text="brandPromotionalBanner.page.subtitle" />
                            </Subtitle>
                        </HeaderLeft>
                        <HeaderRight>
                            <CarouselDelayCard
                                initialValue={carouselDelayMs}
                                onSave={saveCarouselDelay}
                                isSaving={isSavingCarouselDelay}
                            />
                            <SvyButton onClick={openCreateModal} size="s">
                                <FormattedMessage id="brandPromotionalBanner.action.create" />
                            </SvyButton>
                        </HeaderRight>
                    </Header>

                    <Table
                        rows={rows}
                        columns={headers}
                        isLoading={isLoading}
                        isSortable
                        defaultSortBy={[{ id: 'status', desc: false }]}
                        hasPagination
                        onRowClick={handleRowClick}
                        customRowProps={customRowProps}
                        emptyMessageId="brandPromotionalBanner.page.empty"
                        emptyTableChildren={
                            <SvyButton onClick={openCreateModal} size="s" style={{ marginTop: 16 }}>
                                <FormattedMessage id="brandPromotionalBanner.action.create" />
                            </SvyButton>
                        }
                    />
                </HeaderContainer>
            </Container>
        </RouterNavigationTabs>
    );
};

export default BrandPromotionalBanners;
